import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import {
  DESTROY_BACKDROP,
  FETCH_ALL_FORECAST_SCHEDULES,
  FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES,
  FETCH_ALL_FORECAST_SCHEDULES_LOADING,
  OPEN_BACKDROP,
  UPDATE_DELIVERY_SCHEDULE_FORECAST,
  FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES_LOADING,
} from "../types";

export const fetchAllForecastSchedules = () => (dispatch) => {
  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllForecastSchedules`
    )
    .then((res) => {
      console.log("res.data", res.data);
      dispatch({
        type: FETCH_ALL_FORECAST_SCHEDULES_LOADING,
        payload: false,
      });
      dispatch({
        type: FETCH_ALL_FORECAST_SCHEDULES,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULES,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULES,
          payload: {
            status: false,
            errorDescription:
              "Something went wrong. Please contact Schrocken Support.",
          },
        });
      }
    });
};

export const updateDeliveryScheduleForecast = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: `Please don't refresh or close the tab while processing`,
  });

  setTimeout(() => {
    dispatch({
      type: DESTROY_BACKDROP,
    });
    dispatch({
      type: UPDATE_DELIVERY_SCHEDULE_FORECAST,
      payload: { status: true },
    });
  }, 2000);

  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDeliveryScheduleForecast `,
      data
    )
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_DELIVERY_SCHEDULE_FORECAST,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      if (err?.response?.status === 400 || err?.response?.status === 500) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_DELIVERY_SCHEDULE_FORECAST,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_DELIVERY_SCHEDULE_FORECAST,
          payload: {
            status: false,
            errorDescription:
              "Something went wrong. Please contact schrocken support.",
            // errorDescription: {
            //   error: "Something went wrong. Please contact schrocken support.",
            // },
          },
        });
      }
    });
};

export const fetchAllForecastScheduleApprovalRoles = (data) => (dispatch) => {
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllForecastScheduleApprovalRoles`,
      data
    )
    .then((res) => {
      dispatch({
        type: FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES_LOADING,
        payload: false,
      });

      dispatch({
        type: FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES,
          payload: {
            status: false,
            errorDescription:
              "Something went wrong. Please contact Schrocken Support.",
          },
        });
      }
    });
};
